import { Injectable, Component, inject, Input } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from "@angular/material/snack-bar";
import { OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";

@Injectable({
    providedIn: 'root'
})
export class SnackBarService {
    private _snackBar = inject(MatSnackBar);
    private snackBarRef?: MatSnackBarRef<GenericSnackBarComponent>;

    public showSnackBar(
        type: 'success' | 'error' | 'warning',
        message: string,
        config?: MatSnackBarConfig
    ) {
        const defaultConfig: MatSnackBarConfig = {
            horizontalPosition: "right",
            verticalPosition: "top",
            duration: 3000,
            panelClass: `snackbar-${type}`
        };

        const finalConfig = { ...defaultConfig, ...config };

        this.snackBarRef = this._snackBar.openFromComponent(GenericSnackBarComponent, {
            data: { type, message },
            ...finalConfig
        });
    }

    public closeSnackBar() {
        this.snackBarRef?.dismiss();
    }
}

@Component({
    selector: 'app-generic-snackbar',
    standalone: true,
    template: `
    <div class="snackbar-content" [ngClass]="type">
      <span class="snackbar-message">{{ message }}</span>
      <button class="snackbar-close" (click)="closeSnackbar()">✖</button>
    </div>
  `,
    styles: [`
      .snackbar-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 16px;
          border-radius: 8px;
          box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
          font-size: 14px;
          font-weight: 500;
      }
      .snackbar-message {
          flex-grow: 1;
      }
      .snackbar-close {
          background: transparent;
          border: none;
          color: white;
          font-size: 16px;
          cursor: pointer;
      }
      .success { background-color: #4caf50; color: white; }
      .error { background-color:rgb(235, 97, 87); color: white; }
      .warning { background-color: #ff9800; color: white; }
  `],
    imports: [CommonModule]
})
export class GenericSnackBarComponent implements OnInit {
    @Input() type: string = 'success';
    @Input() message: string = '';

    constructor(private snackBarRef: MatSnackBarRef<GenericSnackBarComponent>) { }

    ngOnInit() {
        const data = this.snackBarRef.containerInstance.snackBarConfig.data;
        this.type = data?.type || 'success';
        this.message = data?.message || '';
    }

    closeSnackbar() {
        this.snackBarRef.dismiss();
    }
}
